import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faSearch } from '@fortawesome/pro-regular-svg-icons';
import cn from 'classnames';
import PropTypes from 'prop-types';
import './ShopDiscoverHeader.scss';

import { focusShopSearch } from '../../Actions/UIActions';
import { getShopFeaturedResultsForType, getFeatureDisplayData } from '../../Helpers/featured_helpers';

const ShopDiscoverHeader = props => {
  // Get Featured Creators
  const features = getShopFeaturedResultsForType(props.featured, props.tab, props.activeSection);
  const [featuredFeature, setFeaturedFeature] = React.useState(features[0]);
  const featureIndex = features.findIndex(feature => feature.id === featuredFeature?.id);
  const previousFeaturedFeature = features[featureIndex - 1];
  const nextFeaturedFeature = features[featureIndex + 1];
  const thirdFeaturedFeature = features[featureIndex + 2];
  React.useEffect(() => {
    setFeaturedFeature(features[0]);
  }, [features.length, props.tab]);

  const goToNextFeature = () => {
    if (nextFeaturedFeature) {
      window.__ADD_EVENT__('Shop - Discover - Toggle Feature Arrows');
      setIsChangingFeaturedFeature(true);
      setFeaturedFeature(nextFeaturedFeature);
    }
  };

  const goToPreviousFeature = () => {
    if (previousFeaturedFeature) {
      window.__ADD_EVENT__('Shop - Discover - Toggle Feature Arrows');
      setIsChangingFeaturedFeature(true);
      setFeaturedFeature(previousFeaturedFeature);
    }
  };

  // Image Loading
  const [isChangingFeaturedFeature, setIsChangingFeaturedFeature] = React.useState(false);
  const onLoadPrimaryImage = () => {
    setIsChangingFeaturedFeature(false);
  };

  React.useEffect(() => {
    setIsChangingFeaturedFeature(true);
  }, [props.tab]);

  // UI
  const displayData = getFeatureDisplayData(featuredFeature);
  const tabs = [
    {
      label: 'Curators',
      variable: 'curators'
    },
    {
      label: 'Circles',
      variable: 'circles'
    },
    {
      label: 'Brands',
      variable: 'brands'
    },
    {
      label: 'Categories',
      variable: 'categories'
    }
  ].map(tab => ({
    ...tab,
    active: tab.variable === props.tab
  }));

  const additionalClasses = {
    'changing-featured-feature': isChangingFeaturedFeature
  };

  return (
    <div className='shop-discover-header-container'>
      <div className='primary-data'>
        <div className='tab-dots'>
          {tabs.map(tab => (
            <Link key={tab.variable} className={cn('dot', { active: tab.active })} to={`/shop/discover/${tab.variable}`} />
          ))}
        </div>
        <div className='shop-by-container'>
          <div className='label'>Shop By</div>
          <div className='line' />
        </div>
        {featuredFeature && (
          <div className='featured-creator'>
            <div className='type'>{displayData.singularType}</div>
            <div className='name'>{displayData.title}</div>
            <div className='description'>{displayData.description || 'Shop recommendations'}</div>
            <div className='actions'>
              <Link to={displayData.link} className='shop-btn'>
                {displayData.linkDisplay}
              </Link>
              <div className='search-btn' onClick={() => props.focusShopSearch()}>
                <FontAwesomeIcon icon={faSearch} />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className='secondary-data'>
        <div className='primary-image-container'>
          {featuredFeature && (
            <Link to={displayData.link}>
              <img
                className={cn(additionalClasses)}
                onLoad={onLoadPrimaryImage}
                src={featuredFeature.nonTextImage || featuredFeature.image}
                alt={featuredFeature.title}
              />
            </Link>
          )}
          <div className='toggle-next-image'>
            <div className={cn('arrow', { disabled: !previousFeaturedFeature })} onClick={goToPreviousFeature}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </div>
            <div className={cn('arrow', { disabled: !nextFeaturedFeature })} onClick={goToNextFeature}>
              <FontAwesomeIcon icon={faArrowRight} />
            </div>
          </div>
        </div>
        <div className='secondary-images-container'>
          {nextFeaturedFeature && (
            <div className='secondary-image-container'>
              <img
                className={cn(additionalClasses)}
                src={nextFeaturedFeature.nonTextImage || nextFeaturedFeature.image}
                alt={nextFeaturedFeature.title}
              />
            </div>
          )}
          {thirdFeaturedFeature && (
            <div className='secondary-image-container'>
              <img
                className={cn(additionalClasses)}
                src={thirdFeaturedFeature.nonTextImage || thirdFeaturedFeature.image}
                alt={thirdFeaturedFeature.title}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ShopDiscoverHeader.propTypes = {
  tab: PropTypes.string.isRequired,
  featured: PropTypes.object.isRequired,
  focusShopSearch: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { featured } = state;
  return { featured };
};

export default connect(mapStateToProps, {
  focusShopSearch
})(ShopDiscoverHeader);
